import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../utils/api';
import { toast } from 'react-toastify';



export const getAllScheduleOrderThunk = createAsyncThunk(
    'schedule/getAllScheduleOrderThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getAllScheduleOrders(id);
            return response.data;
        } catch (error) {
            console.log(error);  
        }
    }
);

export const exportScheduleOrderThunk = createAsyncThunk(
    'schedule/exportScheduleOrderThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getAllScheduleOrders(id);
            return response.data;
        } catch (error) {
            console.log(error);  
        }
    }
);

export const getScheduleOrderDetailsThunk = createAsyncThunk(
    'schedule/getAllScheduleOrderDetailsThunk',
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.getScheduleOrderdetails(id);
            return response.data?.data;
        } catch (error) {
            console.log(error);  
        }
    }
);



const scheduleOrderSlice = createSlice({
    name: 'schedule',
    initialState: {
        scheduleOrder: [],
        loading: false,
        error: null,
        refresh : false,
        page:1,
        orderDetails:{},
        status:''
    },
    reducers: {
        setScheduleOrderRefresh:(state,action)=>{
            state.refresh = !state.refresh
        },
        setSchedulePage:(state,action)=>{
            state.page = action.payload
        },
        setScheduleStatus:(state,action)=>{
            state.status = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
           
            //getCartdetails
            .addCase(getAllScheduleOrderThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getAllScheduleOrderThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.scheduleOrder = action.payload;
            })
            .addCase(getAllScheduleOrderThunk.rejected, (state, action) => {
                state.loading = false;
            })


            .addCase(getScheduleOrderDetailsThunk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getScheduleOrderDetailsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.orderDetails = action.payload;
            })
            .addCase(getScheduleOrderDetailsThunk.rejected, (state, action) => {
                state.loading = false;
            });
    },
});

export const { setScheduleOrderRefresh,setSchedulePage,setScheduleStatus } = scheduleOrderSlice.actions
export default scheduleOrderSlice.reducer;

